module.exports = __webpack_public_path__ + "static/media/bsu-logo.3c101142.svg";